import React, { useState } from "react";
import System from "src/helper/system";
import Constants from "src/helper/Constants";
import Helper from "src/helper/Helper";

const DisplayLongDescriptionAndVariantMFRName = (props) => {
  const { currentProduct, no_show_more } = props;
  const { DescriptionLength: { More, Less } } = Constants
  const [action_here, set_action_here] = useState(More);
  const defaultDescLength = 100;
  const shortDescription = currentProduct?.ShortDescription && currentProduct.ShortDescription.length > defaultDescLength ? currentProduct.ShortDescription.substring(0, defaultDescLength) : '';

  return (
    <>
      {currentProduct?.ManufacturerName &&
        <div className="text-black-stone cursor-default">
          <div className="d-inline text-wrap w-auto">by&nbsp;</div>
          <a
            href={`/${System.avUserInfoData.speedBoatNameLower}/manufacturers/m/${Helper.replaceSpecialChar(currentProduct.ManufacturerName?.toLowerCase())}/`}
            className="text-blue text-break cursor-pointer"
            title={currentProduct.ManufacturerName}
          >
            {currentProduct.ManufacturerName}
          </a>
        </div>
      }

      {currentProduct?.ShortDescription &&
        <div className="summary more_summary mt-0 cursor-default">
          {action_here === More && shortDescription && !no_show_more ?
            <p className="mob-font-13">{shortDescription}
              <a className="more-link" onClick={(e) => {
                e.stopPropagation();
                set_action_here(Less)
              }}
              > …More</a>
            </p> : <p className="mob-font-13">{currentProduct.ShortDescription}</p>}
        </div>
      }
    </>
  );
};

export default DisplayLongDescriptionAndVariantMFRName;
